import { fetchCsrfInfo } from '../../App/apiWrapper';
import { csrfInfoSingleton } from './csrf';

export const initCsrfInfo = async () => {
  const csrfInfo = await fetchCsrfInfo();
  csrfInfoSingleton.init(csrfInfo);
};
